import { api } from 'utils/apis/api';
export const smsApi = api
    .enhanceEndpoints({
    addTagTypes: ['Sms'],
})
    .injectEndpoints({
    endpoints: (builder) => ({
        readSmsNumbersQueues: builder.query({
            query: ({ numbers }) => ({
                version: 1,
                path: 'sms/number-queues',
                params: { numbers: numbers.join(',') },
            }),
            providesTags: (_response, _error, queryArg) => [
                ...queryArg.numbers.map((number) => ({
                    type: 'Sms',
                    id: number,
                })),
            ],
        }),
        updateSmsNumberQueue: builder.mutation({
            query: ({ queueId, phoneNumber }) => ({
                version: 1,
                path: 'sms/number-queues',
                method: 'POST',
                body: {
                    number: phoneNumber,
                    queue: { id: queueId },
                },
            }),
            invalidatesTags: (_response, _error, { phoneNumber }) => [
                { type: 'Sms', id: phoneNumber },
            ],
        }),
    }),
});
